import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { FormFieldsTranslations } from "./translations";

interface FormFieldsProps {
  name: string;
  email: string;
  message: string;
  onNameChange: (value: string) => void;
  onEmailChange: (value: string) => void;
  onMessageChange: (value: string) => void;
  validateName: (name: string) => boolean;
  validateEmail: (email: string) => boolean;
  translations: FormFieldsTranslations;
}

export const FormFields = ({
  name,
  email,
  message,
  onNameChange,
  onEmailChange,
  onMessageChange,
  validateName,
  validateEmail,
  translations,
}: FormFieldsProps) => {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="name" className="text-gray-700 dark:text-gray-300">
          {translations.name} *
        </Label>
        <Input
          id="name"
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          required
          placeholder={translations.namePlaceholder}
          className={`bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 ${
            !validateName(name) && name ? "border-red-500" : ""
          }`}
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="email" className="text-gray-700 dark:text-gray-300">
          {translations.email} *
        </Label>
        <Input
          id="email"
          type="email"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          required
          placeholder={translations.emailPlaceholder}
          className={`bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 ${
            !validateEmail(email) && email ? "border-red-500" : ""
          }`}
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="message" className="text-gray-700 dark:text-gray-300">
          {translations.message}
        </Label>
        <Textarea
          id="message"
          value={message}
          onChange={(e) => onMessageChange(e.target.value)}
          placeholder={translations.messagePlaceholder}
          className="resize-none bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100"
          rows={4}
        />
      </div>
    </>
  );
};